import { Authenticator, useAuthenticator, View } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import SwitchComponent from "./containers/SwitchComponent";
import MyLogin from "./components/auth/MyLogin";
import MyTOTPSetup from "./components/auth/MyTOTPSetup";
import MyConfirmSignIn from "./components/auth/MyConfirmSignIn";
import MyForgotPassword from "./components/auth/MyForgotPassword";
import MyRequireNewPassword from "./components/auth/MyRequireNewPassword";
import MyVerifyContact from "./components/auth/MyVerifyContact";
import {CONST} from './environments/environment'

function Router() {
  const {
    route,
    updateForm,
    submitForm,
    toForgotPassword,
    toSignIn,
    signOut,
    username,
    error,
    user,
    unverifiedUserAttributes,
    skipVerification,
    totpSecretCode,
  } = useAuthenticator((ctx) => [
    ctx.route,
    ctx.username,
    ctx.error,
    ctx.user,
    ctx.unverifiedUserAttributes,
    ctx.totpSecretCode,
  ]);

  // 認証済みの場合はアプリ画面へ
  if (route === CONST.AMPLIFY.AUTH_STATE.AUTHENTICATED) {
    return <SwitchComponent signOut={signOut} />;
  }

  // 認証済み以外の場合は認証画面へ
  return (
    <>
      {/* 1. サインイン画面 */}
      <MyLogin
        authState={route}
        updateForm={updateForm}
        submitForm={submitForm}
        toForgotPassword={toForgotPassword}
        error={error}
      />

      {/* 2. MFA付きサインイン画面 */}
      <MyConfirmSignIn
        authState={route}
        updateForm={updateForm}
        submitForm={submitForm}
        error={error}
      />

      {/* 3. Email検証画面 */}
      <MyVerifyContact
        authState={route}
        updateForm={updateForm}
        submitForm={submitForm}
        unverifiedUserAttributes={unverifiedUserAttributes}
        skipVerification={skipVerification}
        error={error}
      />

      {/* 4. パスワードリセット画面 */}
      <MyForgotPassword
        authState={route}
        toSignIn={toSignIn}
        updateForm={updateForm}
        submitForm={submitForm}
        error={error}
      />

      {/* 5. 初回サインイン時のパスワード変更画面 */}
      <MyRequireNewPassword
        authState={route}
        updateForm={updateForm}
        submitForm={submitForm}
        toSignIn={toSignIn}
        error={error}
      />

      {/* 6. TOTP セットアップ画面 */}
      <MyTOTPSetup
        authState={route}
        username={username}
        totpSecretCode={totpSecretCode}
        updateForm={updateForm}
        submitForm={submitForm}
        error={error}
      />
    </>
  );
}

const App = () => {
  return (
    <Authenticator.Provider>
        {/* 
        重要：Authenticator UI を必ずレンダリングしなければいけないため、スタイルで非表示にする
        https://stackoverflow.com/questions/74261254/authstatus-is-not-changing-from-configuring-state-using-amplify-ui-react
       */}
      <style>{`[data-amplify-authenticator]{display:none;}`}</style>
      <View>

        <Authenticator hideSignUp />

        {/* route の監視 */}
        <Router />
      </View>
    </Authenticator.Provider>
  );
};
export default App;
